<template>
  <div>
    <my-tab :tab="tab" :active="active" @tab="reTab"></my-tab>
    <div id="mylist" style="top: 100px">
      <div id="aedser" v-show="now == 1"></div>
      <Table v-show="now == 2" :columns="columns" :data="tableData"></Table>
    </div>
  </div>
</template>
<script>
import echarts from "echarts";
import axios from "axios";
export default {
  data() {
    return {
      tab: [
        { title: "图表", mark: 1 },
        { title: "表格", mark: 2 },
      ],
      active: 0,
      now: 1,
      columns: [
        {
          title: "车牌号",
          key: "carNo",
          minWidth: 80,
          maxWidth: 200,
          tooltip: true,
        },
        {
          title: "当月总支出/元",
          key: "totalCost",
          minWidth: 80,
          maxWidth: 200,
          tooltip: true,
        },
        {
          title: "日常费用/元",
          key: "otherCost",
          minWidth: 80,
          maxWidth: 200,
          tooltip: true,
        },
        {
          title: "加油费用/元",
          key: "refuelCost",
          minWidth: 80,
          maxWidth: 200,
          tooltip: true,
        },
        {
          title: "维修费用/元",
          key: "repairCost",
          minWidth: 80,
          maxWidth: 200,
          tooltip: true,
        },
        {
          title: "保养费用/元",
          key: "careCost",
          minWidth: 80,
          maxWidth: 200,
          tooltip: true,
        },
        {
          title: "违章费用/元",
          key: "violationCost",
          minWidth: 80,
          maxWidth: 200,
          tooltip: true,
        },
      ],
      tableData: [],
      myData:[[]]
    };
  },
  methods: {
    getData() {
      let params = {
        carIdList: this.carIdList,
        pageNumber: this.pageNumber,
        pageSize: this.pageSize,
      };
      this.utils.loading(this, "加载中");
      axios({
        method: "post",
        url: axios.serverWeb + "/ansCost/month",
        data: params,
      }).then((res) => {
        this.$Spin.hide(); //关闭加载
        this.tableData = res.data.data.dataList;
        this.total = res.data.data.total;
        var arr = [];
        this.myData = [[]];
        var obj = [
          {
            name: "维修",
            type: "bar",
            stack: "数据分析",
            color: ["#8db3ff"],
            data: [],
          },
          {
            name: "保养",
            type: "bar",
            stack: "数据分析",
            color: ["#c492f8"],
            data: [],
          },
          {
            name: "日常",
            type: "bar",
            stack: "数据分析",
            color: ["#ff8dd3"],
            data: [],
          },
          {
            name: "加油",
            type: "bar",
            stack: "数据分析",
            color: ["#fab296"],
            data: [],
          },
          {
            name: "违章",
            type: "bar",
            stack: "数据分析",
            color: ["#81e8ec"],
            data: [],
          },
        ];
        for (const i in this.tableData) {
          this.myData[0].push(this.tableData[i].carNo);
          obj[0].data.push(this.tableData[i].repairCost);
          obj[1].data.push(this.tableData[i].careCost);
          obj[2].data.push(this.tableData[i].otherCost);
          obj[3].data.push(this.tableData[i].refuelCost);
          obj[4].data.push(this.tableData[i].violationCost);
        }
        this.myData.push(obj);
        this.drawBar();
        //处理表格
      });
    },
    drawBar() {
      console.log(123);
      var that = this;
      this.chart = echarts.init(document.getElementById("aedser"));
      this.option = {
        backgroundColor: "",
        tooltip: {
          trigger: "axis",
          axisPointer: {
            // Use axis to trigger tooltip
            type: "shadow", // 'shadow' as default; can also be 'line' or 'shadow'
          },
        },
        legend: {},
        grid: {
          left: "3%",
          right: "4%",
          bottom: "3%",
          containLabel: true,
        },
        xAxis: {
          type: "value",
          
        },
        yAxis: {
          type: "category",
          data: this.myData[0],
          inverse:true
        },
        series: this.myData[1],
      };
      this.chart.setOption(this.option);

      this.chart.resize();
    },
    reTab(v) {
      this.now = v.mark;
      if (this.now == 1) {
        setTimeout(() => {
          this.drawBar();
        }, 500);
      }
    },
  },
  mounted() {
    // this.drawBar()
  },
};
</script>
<style lang="">
#aedser {
  width: 100%;
  height: 100%;
}
</style>


// WEBPACK FOOTER //
// src/components/fenxi/feiyong/month.vue